import React from "react";
import { Camera, CameraOff, Mic, MicOff, PhoneOff, RefreshCw } from "lucide-react";

export default function RoboControlBar({ isCameraOn, isListening, facing, toggleCamera, toggleListening, flipCamera, endCall }) {
  const btn = (active, disabled, danger) =>
    `rounded-full flex items-center justify-center transition-all active:scale-95 ${
      danger
        ? "w-12 h-9 md:w-10 md:h-7 bg-[var(--danger)] text-white"
        : `w-9 h-9 md:w-7 md:h-7 ${
            disabled ? "opacity-40 pointer-events-none bg-[var(--surface2)] border border-[var(--bd)] text-[var(--t1)]"
            : active ? "bg-[var(--accent)] text-black"
            : "bg-[var(--surface2)] border border-[var(--bd)] text-[var(--t1)] hover:border-[var(--accent)]"
          }`
    }`;

  return (
    <div className="col-span-2 flex items-start justify-center z-30">
      <div className="inline-flex items-center gap-1.5 md:gap-1 rounded-full bg-[var(--surface)] px-3 py-1.5 md:px-2 md:py-1 border border-[var(--bd)] shadow-lg">
        <button onClick={toggleListening} disabled={!isCameraOn} className={btn(isListening, !isCameraOn)} title={isListening ? "Mute" : "Unmute"}>
          {isListening ? <Mic size={16} className="md:w-3.5 md:h-3.5" /> : <MicOff size={16} className="md:w-3.5 md:h-3.5" />}
        </button>
        <button onClick={toggleCamera} className={btn(isCameraOn)} title={isCameraOn ? "Turn off camera" : "Turn on camera"}>
          {isCameraOn ? <Camera size={16} className="md:w-3.5 md:h-3.5" /> : <CameraOff size={16} className="md:w-3.5 md:h-3.5" />}
        </button>
        <button onClick={flipCamera} disabled={!isCameraOn} className={btn(false, !isCameraOn)} title={`Switch to ${facing === "user" ? "back" : "front"} camera`}>
          <RefreshCw size={16} className="md:w-3.5 md:h-3.5" />
        </button>
        <button onClick={endCall} className={btn(false, false, true)} title="End call">
          <PhoneOff size={16} className="md:w-3.5 md:h-3.5" />
        </button>
      </div>
    </div>
  );
}
